import { render } from "./abrirProposta.vue?vue&type=template&id=ff3a0608&scoped=true"
import script from "./abrirProposta.vue?vue&type=script&lang=js"
export * from "./abrirProposta.vue?vue&type=script&lang=js"

import "./abrirProposta.vue?vue&type=style&index=0&id=ff3a0608&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3a0608"]])

export default __exports__